import { render, staticRenderFns } from "./ColumnReport.vue?vue&type=template&id=20456c80"
import script from "./ColumnReport.vue?vue&type=script&lang=js"
export * from "./ColumnReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20456c80')) {
      api.createRecord('20456c80', component.options)
    } else {
      api.reload('20456c80', component.options)
    }
    module.hot.accept("./ColumnReport.vue?vue&type=template&id=20456c80", function () {
      api.rerender('20456c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/ColumnReport.vue"
export default component.exports